import { ArrowRight } from "lucide-react";
import type { ExampleItem, WorkflowDetail } from "../types";
import { MADE_UP_NOTE } from "../utils/format";
import { ExampleCard } from "./ExampleCard";

const ExampleColumn = ({
  id,
  title,
  items,
}: {
  id: string;
  title: string;
  items: ExampleItem[];
}) => (
  <section aria-labelledby={id} className="min-w-0">
    <h4 id={id} className="text-xs font-semibold uppercase tracking-wide text-zinc-700">
      {title}
    </h4>
    <ul className="mt-2 space-y-3">
      {items.map((item) => (
        <ExampleCard key={item.label} item={item} />
      ))}
    </ul>
  </section>
);

/** What the user gives the workflow at the start, and what the workflow gives back. */
export const WorkflowExample = ({ detail }: { detail: WorkflowDetail }) => (
  <section
    aria-labelledby="workflow-example"
    className="rounded-xl border border-zinc-200 bg-zinc-50 p-5"
  >
    <h3 id="workflow-example" className="text-base font-semibold text-zinc-900">
      Example input and output
    </h3>
    <p className="mt-1 text-sm text-zinc-600">
      What the user gives at the start, and what the workflow gives back. {MADE_UP_NOTE}
    </p>
    <div className="mt-4 grid items-start gap-4 lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]">
      <ExampleColumn id="workflow-example-input" title="Input" items={detail.example.inputs} />
      <ArrowRight className="mt-8 hidden h-5 w-5 text-zinc-400 lg:block" aria-hidden />
      <ExampleColumn id="workflow-example-output" title="Output" items={detail.example.outputs} />
    </div>
  </section>
);
